export class getAssets {
    static readonly type = '[Asset Detail] Get Asset Detail'
    constructor(public id: string){}
}

export class resetAsset {
    static readonly type = '[Asset Detail] Reset Asset Detail';
    constructor() { }
}